import React, { useState } from "react";
import {
  Text,
  Box,
  Center,
  SimpleGrid,
  Button,
  Checkbox,
  Image,
} from "@chakra-ui/react";

import { createCampaignAtom } from "../../../atoms/campaigns";
import { useRecoilState } from "recoil";
// import CustomTemplate from "../../UI/form/CustomTemplate";
import { useQuery } from "@tanstack/react-query";
import { getTemplates } from "../../../API/account/templates";
import { TemplateSMSCard } from "../../UI/Cards/templateSMSCard";
import ProgressLoader from "../../UI/ProgressLoader";
// import NoEventsIcons from "../../../icons/NoEventsIcons";
import { ButtonPrimary } from "../../UI/Buttons";
import { EmptyTemplateIcon } from "../../../icons/EmptyTemplateIcon";
import { TemplateEmailCard } from "../../UI/Cards/templateEmailCard";
import { TemplateEmailVisualCard } from "../../UI/Cards/templateEmailVisualCard";
// import { useNavigate } from "react-router-dom";

const EmailCampaignTemplates = () => {
  const [currentStageData, setCurrentStageData] =
    useRecoilState(createCampaignAtom);

  const [emailTemplates, setEmailTemplates] = useState([]);

  // const navigate = useNavigate();
  const { isLoading } = useQuery(["user_templates"], () => getTemplates(), {
    onSuccess: (data) => {
      setEmailTemplates(data.whatsappTemplates?.docs);
    },
  });

  const filteredTemplates =
    currentStageData?.data?.builder !== "visual_builder"
      ? emailTemplates.filter(
          (item: any) => item.template_type !== "Visual Builder"
        )
      : emailTemplates.filter(
          (item: any) => item.template_type !== "Text Builder"
        );

  console.log("emailTemplates", emailTemplates);

  if (currentStageData?.data?.builder === "visual_builder") {
    return (
      <Box p={10}>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Box>
            <Text fontWeight={700} fontSize={20}>
              {" "}
              Select Template
            </Text>
            <Text color={"#7489AA"} fontSize={12} fontWeight={500}>
              {" "}
              Select your campaign type below
            </Text>
          </Box>
          <Box>
            {" "}
            <Button
              mx={"2"}
              rounded={"md"}
              bg={"#0066FF"}
              color={"white"}
              w={"133px"}
              isDisabled={!currentStageData?.data?.template_uid}
              onClick={() => {
                setCurrentStageData((prevData) => {
                  return {
                    ...prevData,
                    currentStage: "Campaign Builder",
                  };
                });
              }}
            >
              Next
            </Button>
          </Box>
        </Box>
        <Box mt={10} display={"flex"}>
          <TemplateEmailVisualCard
            uid="blank"
            title="Create Campaign"
            content=""
            design={""}
          />
        {isLoading ? <ProgressLoader /> : null}

          {filteredTemplates?.length > 0
            ? filteredTemplates?.map((item: any, index: number) => (
                <TemplateEmailVisualCard
                  uid={item.uid}
                  title={item.name}
                  content={item.template_body?.[0]}
                  design={item.template_data?.[0]}
                  key={index}
                />
              ))
            : null}

          {/* <Box height={259.92} w={241.63} border={selectedTemplate === 1 ? '1px solid #0066FF': '1px solid #D6E7FF'} mr={5} role="button" onClick={()=>{setSelectedTemplate(1)}} >
            <Box h={'80%'} bg={'#F7FBFF'}>
                <Box display={'flex'} justifyContent={'end'} p={2}>
                <Checkbox isChecked={selectedTemplate === 1} defaultChecked bg={"white"}/>
                </Box>
                <Box mt={10}>
                <Image src="/blank.png" margin={'auto'}/>
                </Box>
            </Box>
            <Text fontWeight={500} fontSize={12} textAlign={'center'} mt={3}>Template 2</Text>

        </Box> */}
        </Box>
      </Box>
    );
  }

  return (
    <Box w="full">
      {isLoading ? <ProgressLoader /> : null}

      <Box maxW={"460px"} mx="auto" mb="28px">
        <Text fontSize={"20px"} fontWeight={700} color="grays.8">
          Templates
        </Text>
        <Text color={"grays.12"} fontSize="xs" mt="8px" fontWeight={600}>
          Please select a template you’d like to use
        </Text>
      </Box>

      <Box
        width={"500px"}
        mx={"auto"}
        maxHeight={"50vh"}
        overflowX={"visible"}
        overflowY={"auto"}
        className="thinSB"
        borderColor={"borders.100"}
        // borderRightWidth={"1px"}
      >
        <SimpleGrid p={"24px"} gridTemplateColumns="repeat(2, 1fr)" gap="24px">
          <Center
            flexDir={"column"}
            py={"6px"}
            borderWidth={"1px"}
            borderColor={"borders.100"}
          >
            <Box pt={"4px"} mb={"8px"}>
              <EmptyTemplateIcon height={"38px"} />
            </Box>
            <Text
              mb={"12px"}
              maxWidth={"140px"}
              textAlign={"center"}
              fontWeight={700}
              fontSize={"12px"}
              color={"grays.9"}
            >
              {filteredTemplates?.length > 0
                ? `Blank template`
                : `You haven’t created any templates yet`}
            </Text>
            <ButtonPrimary
              buttonProps={{ mb: "6px" }}
              onClick={() => {
                // navigate(`/account/templates/SMS/create`);
                // setCurrentStageData((prevData) => {
                //   return {
                //     ...prevData,
                //     currentStage: "Campaign Builder",
                //   };
                // });
                setCurrentStageData((prevValue) => {
                  return {
                    ...prevValue,
                    data: {
                      ...prevValue?.data,
                      template_uid: "",
                      sms_body: "",
                    },
                    currentStage: "Campaign Builder",
                  };
                });
              }}
            >
              Create Campaign
            </ButtonPrimary>
          </Center>

          {/* <Center flexDir={"column"}>
            <TemplateEmailCard
              uid={"blank"}
              title={"Blank Template"}
              content={"Hey there, this slate is your stage..."}
            />
          </Center> */}

          {filteredTemplates?.length > 0
            ? filteredTemplates?.map((item: any, index: number) => (
                <Center flexDir={"column"} key={index}>
                  <TemplateEmailCard
                    uid={item.uid}
                    title={item.name}
                    content={item.template_body[0]}
                  />
                </Center>
              ))
            : null}
        </SimpleGrid>
      </Box>

      <Box maxW={"460px"} mx="auto">
        <Button
          isDisabled={!currentStageData?.data?.template_uid}
          onClick={() => {
            setCurrentStageData((prevData) => {
              return {
                ...prevData,
                currentStage: "Campaign Builder",
              };
            });
          }}
          w="full"
          mt="40px"
          mb="10px"
          colorScheme={"primary"}
        >
          Continue to campaign builder
        </Button>
      </Box>
    </Box>
  );
};

export default EmailCampaignTemplates;
